import React from "react";

export default function StreamingIcon(props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" {...props}>
            <g transform="translate(-0.037)">
                <rect width="32" height="32" transform="translate(0.037)" fill="rgba(0,0,0,0.5)" opacity="0"/>
                <g transform="translate(8 9.906)">
                <g transform="translate(0 3.75)">
                    <g>
                        <path d="M2.344,181H0v4.688H2.344a.469.469,0,0,0,.469-.469v-3.75A.469.469,0,0,0,2.344,181Z" transform="translate(0 -181)" fill="rgba(255,255,255,0.6)"/>
                    </g>
                </g>
                <g>
                    <g>
                        <path d="M7.531,64.8V61H1.406A1.408,1.408,0,0,0,0,62.406v1.406H2.344A1.408,1.408,0,0,1,3.75,65.219v3.75a1.408,1.408,0,0,1-1.406,1.406H0v1.406a1.408,1.408,0,0,0,1.406,1.406H7.531v-3.8a2.344,2.344,0,0,1,0-4.593Z" transform="translate(0 -61)" fill="rgba(255,255,255,0.6)"/>
                    </g>
                </g>
                <g transform="translate(13.188 3.75)">
                    <g>
                        <path d="M422.469,181a.469.469,0,0,0-.469.469v3.75a.469.469,0,0,0,.469.469h2.344V181Z" transform="translate(-422 -181)" fill="rgba(255,255,255,0.6)"/>
                    </g>
                </g>
                <g transform="translate(6.594 4.688)">
                    <g>
                        <path d="M212.406,211a1.406,1.406,0,1,0,1.406,1.406A1.408,1.408,0,0,0,212.406,211Z" transform="translate(-211 -211)" fill="rgba(255,255,255,0.6)"/>
                    </g>
                </g>
                <g transform="translate(8.469)">
                    <g>
                        <path d="M276.188,63.813h2.344V62.406A1.408,1.408,0,0,0,277.125,61H271v3.8a2.344,2.344,0,0,1,0,4.593v3.8h6.125a1.408,1.408,0,0,0,1.406-1.406V70.375h-2.344a1.408,1.408,0,0,1-1.406-1.406v-3.75A1.408,1.408,0,0,1,276.188,63.813Z" transform="translate(-271 -61)" fill="rgba(255,255,255,0.6)"/>
                    </g>
                </g>
                </g>
            </g>
        </svg>
    );
}
